import { Campaign, CampaignPartner } from './CampaignPartner';

export const DEFAULT_CAMPAIGN: Campaign = 'booking-popunder';

const BOOKINGCOM_DEFAULT_AID = 884601;
const BOOKINGCOM_OMIO_EXCLUSIVE_DISCOUNT_5P_AID = 2400312;
const BOOKINGCOM_NEW_USER_AID = 2421297;

const partners: { [key: string]: CampaignPartner } = {
  'wl-bookingcom-hotels': {
    campaign: 'wl-bookingcom-hotels',
    name: 'Omio',
    logo: '/static_content/web/omio_logo/png/transparent/OMIO_blue.png',
    fallbackUrl: `https://hotels.omio.com/?utm_source=goeuro&utm_medium=SPPC&utm_content=cm2`,
  },
  'booking-popunder': {
    campaign: 'booking-popunder',
    name: 'Booking.com',
    logo: '/static_content/web/partners/booking-com-logo.png',
    fallbackUrl:
      `https://sp.booking.com/?aid=${BOOKINGCOM_DEFAULT_AID}&utm_source=goeuro&utm_medium=SPPC&utm_content=cm2`,
  },
  'bookingcom-omio-discounts-5p': {
    campaign: 'bookingcom-omio-discounts-5p',
    name: 'Booking.com',
    logo: '/static_content/web/partners/booking-com-logo.png',
    fallbackUrl: `https://sp.booking.com/?aid=${BOOKINGCOM_OMIO_EXCLUSIVE_DISCOUNT_5P_AID}&utm_source=goeuro&utm_medium=SPPC&utm_content=cm2`,
  },
  'bookingcom-new-user': {
    campaign: 'bookingcom-new-user',
    name: 'Booking.com',
    logo: '/static_content/web/partners/booking-com-logo.png',
    fallbackUrl: `https://sp.booking.com/?aid=${BOOKINGCOM_NEW_USER_AID}&utm_source=goeuro&utm_medium=SPPC&utm_content=cm2`,
  },
  bookingcom_mobile_checkbox: {
    campaign: 'bookingcom_mobile_checkbox',
    name: 'Booking.com',
    logo: '/static_content/web/partners/booking-com-logo.png',
    fallbackUrl:
      `https://sp.booking.com/?aid=${BOOKINGCOM_DEFAULT_AID}&utm_source=goeuro&utm_medium=SPPC&utm_content=cm2`,
  },
  getyourguide: {
    campaign: 'getyourguide',
    name: 'GetYourGuide',
    logo: '/static_content/web/partners/gyg-logo.svg',
    fallbackUrl: 'https://www.getyourguide.com/?partner_id=PGSHZ7K&cmp=tps_fallback',
  },
  rentalcars: {
    campaign: 'rentalcars',
    name: 'Rentalcars.com',
    logo: '/static_content/web/partners/wordmark-rclogo_194x30.png',
    fallbackUrl: 'https://www.rentalcars.com/SearchLoaderWidget.do?affiliateCode=goeuro',
  },
  'bookingcom-cars': {
    campaign: 'bookingcom-cars',
    name: 'Booking.com',
    logo: '/static_content/web/partners/booking-com-logo.png',
    fallbackUrl: 'https://www.booking.com/cars/index.en.html?aid=2379443',
  },
  impala: {
    campaign: 'impala',
    name: 'Impala',
    logo: '',
    fallbackUrl: 'https://booking.impala.travel/b/f0df7ee9-4e0c-443d-a179-201eeb1efe2b/hotels',
  },
  expedia: {
    campaign: 'expedia',
    name: 'Expedia',
    logo: '',
    fallbackUrl:
      'https://prf.hn/click/camref:1101lqGZC/destination:https%3A%2F%2Fwww.expedia.it%2Fen%2F',
  },
  vio: {
    campaign: 'vio',
    name: 'Vio',
    logo: '',
    fallbackUrl: 'https://omio.vio.com',
  },
  'kayak-cars': {
    campaign: 'kayak-cars',
    name: 'Kayak',
    logo: '',
    fallbackUrl: 'https://kayak.co.uk/in?a=kan_315144_591211&lc=en&url=%2Fcars',
  },
  'kayak-stays': {
    campaign: 'kayak-stays',
    name: 'Kayak',
    logo: '',
    fallbackUrl: 'https://kayak.co.uk/in?a=kan_315144_591211&lc=en&url=%2Fstays',
  },
};

export default partners;
